import { render, staticRenderFns } from "./GameAction.vue?vue&type=template&id=3d0f453e&scoped=true"
import script from "./GameAction.vue?vue&type=script&lang=js"
export * from "./GameAction.vue?vue&type=script&lang=js"
import style0 from "./GameAction.vue?vue&type=style&index=0&id=3d0f453e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0f453e",
  null
  
)

export default component.exports